import { FC } from 'react';

import { t } from '@onlinepayments/payments-library';

interface IOpeningHoursItemProps {
  span: string | null;
  dayText: string;
}

const OpeningHoursItem: FC<IOpeningHoursItemProps> = ({ dayText, span }) => {
  return (
    <p className="flex justify-between whitespace-no-wrap leading-3">
      <strong>{dayText}:</strong> <span>{span || t('opening_hours_closed')}</span>
    </p>
  );
};

export default OpeningHoursItem;
